<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品分类</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索 新增-->
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForRef"
            label-width="80px"
            autocomplete="on"
            size="mini"
          >
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="请输入分类名称" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item >
              <el-button type="success" @click="searchSubmit()">搜索</el-button>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" @click="addData">新增</el-button>
            </el-form-item>
          </el-form>
        </el-col>

      </el-row>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        height="450"
        row-key="id"
        size="mini"
        border
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">

        <el-table-column :index="indexMethod" type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column label="分类名称" prop="name"></el-table-column>
        <el-table-column label="分类编码" prop="sn"></el-table-column>
        <el-table-column label="分类图片">
          <template slot-scope="scope">
            <img :src="scope.row.cover" style="width:30px;height:30px;border-radius:4px" v-if="scope.row.cover">
          </template>
        </el-table-column>
        <el-table-column label="是否显示" prop="is_show" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_show == 1 ? 'success' : 'danger'">
              {{ scope.row.is_show == 1 ? '显示' : '隐藏' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="130">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handelDel(scope.row)">删除</el-button>
            <el-button @click="handelEdit(scope.row)" type="text" size="mini">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="ruleForm" :rules="rules" ref="form" label-width="80px">

        <el-form-item label="分类名称" prop="name">
          <el-input v-model="ruleForm.name" autocomplete="off" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="分类编码">
          <el-input v-model="ruleForm.sn" autocomplete="off" placeholder="请输入分类编码"></el-input>
        </el-form-item>
        
        <!-- 🔥 修复：下拉框 100% 显示文字 -->
        <el-form-item label="上级分类" prop="parent_id">
          <el-select v-model="ruleForm.parent_id" style="width: 250px;" value-key="id">
            <el-option label="顶级分类（无父级）" value="0"></el-option>
            <el-option 
              :key="item.id" 
              v-for="item in cateMenus" 
              :label="item.pid>0 ? '|--'+item.name : item.name" 
              :value="item.id + ''"
            ></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="图片">
                <i class="el-icon-camera" style="font-size:80px;" v-show="!ruleForm.cat_logo" @click="showImgDoc()"></i>
                <el-image class="main_image" v-show="ruleForm.cat_logo" :src="ruleForm.cat_logo" @click="showImgDoc()"></el-image>
         </el-form-item>

        <!-- <el-form-item label="分类图片">
          <el-upload
            :action="`/api/upload`"
            :headers="{ token: token }"
            :on-success="handleAvatarSuccess"
            :show-file-list="false"
          >
            <img v-if="ruleForm.cover" :src="ruleForm.cover" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="是否显示">
          <el-switch v-model="ruleForm.is_show" active-value="1" inactive-value="0"></el-switch>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  <eDocList :formData="formData1"
              :visible.sync="visible1"
              :title="title1"
              :closeForm="closeForm1"
              v-on:eventChoose="eChooseDoc"
    />
  </div>
</template>

<script>
 import eDocList from "../common/eDocList";

export default {
  components: {eDocList  },
  name: "goodsCategoryList",
  data() {
    return {
        formData1:{},
        title1:'',
        visible1:false,
      token: sessionStorage.getItem('token') || '',
      company_id: sessionStorage.getItem('company_id') || '',
      user_id: sessionStorage.getItem('user_id') || '',
      
      searchForm: { name: "" },
      tableLoadData: [],
      pageNum:1,
      pageSize:10,
      total:0,
      showType: '',
      rules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min:1, max:30, message: "长度在 1 到 30 个字符", trigger: "blur" }
        ],
      },
      dialogFormVisible: false,
      title: '',
      ruleForm: {
        name: '',
        parent_id: "0", // 字符串 0
        id:'',
        sn:"",
        cover: "",
        is_show: "1",
        cat_logo: "",
      },
      cateMenus:[],
    };
  },
  created() {
    this.DataList()
    this.getCateMenus();
  },
  methods: {
     eChooseDoc(id,...params){
        console.log('eChooseDoc',params)
        this.ruleForm.cat_logo=params[1];
      },
      showImgDoc(){
        this.title1="图片选择";
        this.visible1=true;
      },
      closeForm1(){
        this.visible1=false;
      },
    handleAvatarSuccess(res) {
      this.ruleForm.cover = res.data.file;
    },
    getCateMenus(){
      let params={
        access_token: this.token,
        company_id: this.company_id,
      };
      this.$axios.goodsCategoryTable(params).then((res)=>{
        if(res.code == 200) {
          this.cateMenus=res.data;
        }
      });
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    DataList(){
      const param = {
        company_id: this.company_id,
        access_token: this.token,
      }
      this.$axios.goodsCategoryTree(param).then(res=>{
        if(res.code == 200){
          this.tableLoadData = res.data
          this.total = res.data.total || 0
        }
      })
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.DataList()
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    // 新增
    addData() {
      this.title = '新增'
      this.ruleForm = {
        name: '',
        parent_id: "0", // 强制字符串
        id: '',
        sn: '',
        cover: '',
        is_show: '1'
      }
      this.dialogFormVisible = true
    },
    // 编辑
    handelEdit(row) {
      this.ruleForm = {
        id: row.id,
        name: row.name,
        parent_id: row.pid ? String(row.pid) : "0", // 统一转字符串
        sn: row.sn || '',
        cover: row.cover || '',
        cat_logo:row.cat_logo || '',
        is_show: row.is_show + ''
      }
      this.title = '编辑'
      this.dialogFormVisible = true
    },
    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const param = {
            cat_name: this.ruleForm.name,
            cat_id: this.ruleForm.id,
            parent_id: this.ruleForm.parent_id,
            code: this.ruleForm.sn,
            cover: this.ruleForm.cover,
            cat_logo: this.ruleForm.cat_logo,
            is_show: this.ruleForm.is_show,
            company_id: this.company_id,
            access_token: this.token,
          }
          this.$axios.goodsCategorySave(param).then(res =>{
            if(res.code == 200){
              this.DataList()
              this.$message.success(res.msg)
              this.dialogFormVisible = false
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    searchSubmit() {
      this.DataList()
    },
    handelDel(row) {
      this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          operator_id: this.user_id,
          company_id: this.company_id,
          access_token: this.token,
          id: row.id,
        }
        this.$axios.goodsCategoryDel(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
  },
};
</script>

<style>
/* 上传按钮样式 */
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
/* 预览图片样式 + 加边框 */
.avatar {
  width: 80px;
  height: 80px;
  display: block;
  border-radius: 6px;
  border: 1px solid #d9d9d9; /* 🔥 这里加了边框 */
  object-fit: cover;
}
</style>